/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormulaContext, getReadableFormulaExpression } from '@gh/builder-shared';
import { getRouteInitData } from '@gh/common-shared';
import { JeComponent } from '../../../resources/job-estimate-details.model';

@Component({
  standalone: false,
  selector: 'gh-je-details-cc-item',
  templateUrl: 'je-details-cc-item-component.component.html',
  styleUrls: ['je-details-cc-item-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JeDetailsCcItemComponentComponent implements OnInit {
  @Input() component: JeComponent;

  private context: FormulaContext;

  constructor(private route: ActivatedRoute) {

  }

  ngOnInit(): void {
    const { formulaContext } = getRouteInitData(this.route);
    this.context = formulaContext;
  }

  get formula(): string {
    return getReadableFormulaExpression(this.context, this.component.formula);
  }
}
